import { render, staticRenderFns } from "./PlpBulkExpandButton.vue?vue&type=template&id=11a0a9a2&"
import script from "./PlpBulkExpandButton.vue?vue&type=script&lang=js&"
export * from "./PlpBulkExpandButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports